const contactMeData = [
    {
        key: "formDetails",
        formHeading: "Want to connect with me? Or discuss something? Fill in the form below to send me a message via email."
    }
];

export default contactMeData;